import { useEffect, useMemo, useState } from "react";
import { RemoteTileServiceInfoDc } from "@evergis/api";

import { api } from "../../evergis/api";

export const useTileService = (layerName: string) => {
  const [data, setData] = useState<RemoteTileServiceInfoDc | undefined>();
  const [loading, setLoading] = useState<boolean>();
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    if (!layerName) {
      return;
    }

    setLoading(true);
    setError(void 0);

    api.layers
      .getLayerInfo(layerName)
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, [layerName]);

  return useMemo(
    () => ({
      tileLayer: data as RemoteTileServiceInfoDc,
      loading,
      error,
    }),
    [data, loading, error],
  );
};
